import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, from } from 'rxjs';
import { switchMap, take, map } from 'rxjs/operators';
import { RouterStateTrackerService } from '../services/router-state-tracker.service';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private isRedirecting = false;

  constructor(
    private router: Router,
    private routerStateTrackerService: RouterStateTrackerService,
    private authService: AuthService,
    private navCtrl: NavController,
  ) {}

  public canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const isOnboardingRoute = state.url.includes('/onboarding');
    
    return from(this.authService.restoreSession()).pipe(
      switchMap(() => this.authService.isAuthenticated$),
      take(1),
      map((isAuthenticated) => {
        if (isOnboardingRoute) {
          if (isAuthenticated) {
            this.redirectTo('/calendar');
            return false;
          }
          return true;
        } else {
          if (!isAuthenticated) {
            this.redirectTo('/onboarding');
            return false;
          }
          return true;
        }
      }),
    );
  }

  private redirectTo(path: string): void {
    if (!this.isRedirecting) {
      this.isRedirecting = true;
      setTimeout(() => {
        this.navCtrl.navigateRoot(path).then(() => {
          setTimeout(() => { this.isRedirecting = false; }, 500);
        }).catch(() => { this.isRedirecting = false; });
      }, 50);
    }
  }
  navigateToPage(page: string, data: any = { test: 'from AuthGuard' }): void {
    // Safely navigate with error handling
    // The navigateWithPreExitAnimation method has its own fallback handling
    this.routerStateTrackerService.navigateWithPreExitAnimation(page, data).catch((error) => {
      console.error('Auth guard navigation error:', error);
    });
  }
}
